import { type IBugReport } from '@/app/types/settingsTypes'

import style from './ReportsList.module.scss'
import { RepostItem } from './RepostItem/RepostItem'

interface IProps {
    bugReportList: IBugReport[]
    onRemoveBugReport: (id: string) => void
    onSetSearchableAgentId: (searchableAgentId: string | null) => void
}

export const ReportsList = (props: IProps) => {
    const { bugReportList, onRemoveBugReport, onSetSearchableAgentId } = props
    return (
        <div className={style.container}>
            {bugReportList.length > 0 ? (
                bugReportList.map((item) => (
                    <RepostItem
                        key={item.id}
                        {...item}
                        onRemoveBugReport={onRemoveBugReport}
                        onSetSearchableAgentId={onSetSearchableAgentId}
                    />
                ))
            ) : (
                <div className={style.empty}>
                    <span>Нет сообщений от пользователей</span>
                </div>
            )}
        </div>
    )
}
